document.addEventListener('DOMContentLoaded', () => {
  const promo = document.querySelector('[data-quick-account-promo]');
  const accounts = Array.from(document.querySelectorAll('.quick-account shopify-account'));
  const headerAccount = document.querySelector('[data-quick-account-header]');
  const headerAccountComponent = headerAccount?.querySelector('shopify-account');
  const signedOutAvatar = headerAccountComponent?.querySelector('[slot="signed-out-avatar"]');
  const rewardTrigger = document.querySelector('[data-quick-account-reward-trigger]');
  const rewardDialog = document.querySelector('[data-quick-account-reward-dialog]');
  const rewardCode = rewardDialog?.querySelector('[data-quick-account-reward-code]');
  const copyCodeButton = rewardDialog?.querySelector('[data-quick-account-copy-code]');
  const loginHint = document.querySelector('[data-quick-account-login-hint]');
  const loginHintClose = loginHint?.querySelector('[data-quick-account-login-hint-close]');
  const desktop = window.matchMedia('(min-width: 990px)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const loginIntentKey = 'quick-account-login-intent-v1';
  const loginRefreshKey = 'quick-account-login-refreshed-v1';
  const autoOpenKey = 'quick-account-auto-opened-v1';
  const loginIntentLifetime = 30 * 60 * 1000;
  const refreshAfterLogin = headerAccount?.dataset.refreshAfterLogin !== 'false';
  const autoOpenForGuest = headerAccount?.dataset.autoOpenLogin !== 'false';
  let syncTimer;
  let loginStateTimer;
  let hintTimer;
  let nativePanelCache;
  let accountReady = false;
  let leftDuringLogin = false;
  let signedIn = headerAccount?.dataset.initialSignedIn === 'true';

  const hasRecentLoginIntent = () => {
    const startedAt = Number(window.sessionStorage.getItem(loginIntentKey));
    return Number.isFinite(startedAt) && Date.now() - startedAt < loginIntentLifetime;
  };

  const recordLoginIntent = () => {
    window.sessionStorage.setItem(loginIntentKey, String(Date.now()));
  };

  const clearLoginIntent = () => {
    window.sessionStorage.removeItem(loginIntentKey);
    window.sessionStorage.removeItem(loginRefreshKey);
  };

  const refreshStorefrontAfterSignIn = () => {
    if (
      !refreshAfterLogin ||
      !hasRecentLoginIntent() ||
      window.sessionStorage.getItem(loginRefreshKey) === 'true'
    ) {
      return false;
    }

    window.sessionStorage.setItem(loginRefreshKey, 'true');
    window.location.reload();
    return true;
  };

  const isSignedOutAvatarVisible = (account = headerAccountComponent) => {
    const avatar = account?.querySelector('[slot="signed-out-avatar"]');
    if (!avatar) return false;

    const rect = avatar.getBoundingClientRect();
    const style = window.getComputedStyle(avatar);
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  };

  const maybeAutoOpenAccount = () => {
    if (
      !autoOpenForGuest ||
      signedIn ||
      !isSignedOutAvatarVisible(headerAccountComponent) ||
      window.sessionStorage.getItem(autoOpenKey) === 'true'
    ) {
      return;
    }

    window.sessionStorage.setItem(autoOpenKey, 'true');
    signedOutAvatar.click();
  };

  const hideLoginHint = () => {
    window.clearTimeout(hintTimer);
    if (loginHint) loginHint.hidden = true;
  };

  const showLoginHint = () => {
    if (!loginHint || signedIn || !hasRecentLoginIntent()) return;
    loginHint.hidden = false;
    window.clearTimeout(hintTimer);
    hintTimer = window.setTimeout(hideLoginHint, 10000);
  };

  const openReward = () => {
    if (!rewardDialog || typeof rewardDialog.showModal !== 'function') return;
    hidePromo();
    hideLoginHint();
    if (!rewardDialog.open) rewardDialog.showModal();
  };

  const maybeShowReward = () => {
    if (!rewardDialog || !hasRecentLoginIntent()) return;
    clearLoginIntent();
    if (rewardDialog.dataset.autoShow === 'true') {
      window.setTimeout(openReward, 350);
    }
  };

  const syncLoginState = () => {
    if (!accountReady || !headerAccountComponent || !signedOutAvatar) return;

    const nextSignedIn = !isSignedOutAvatarVisible(headerAccountComponent);
    if (rewardTrigger) rewardTrigger.hidden = !nextSignedIn;

    if (nextSignedIn) {
      if (refreshStorefrontAfterSignIn()) return;

      hideLoginHint();
      if (rewardDialog) {
        maybeShowReward();
      } else {
        clearLoginIntent();
      }
    }

    signedIn = nextSignedIn;
  };

  const copyRewardCode = async () => {
    const code = rewardCode?.textContent?.trim();
    if (!code || !copyCodeButton) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    copyCodeButton.textContent = copyCodeButton.dataset.copiedLabel || 'Copied!';
    window.setTimeout(() => {
      copyCodeButton.textContent = copyCodeButton.dataset.copyLabel || 'Copy code';
    }, 1800);
  };

  const getText = (element) =>
    (element.innerText || element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const collectElements = (root, elements = []) => {
    if (!root || typeof root.querySelectorAll !== 'function') return elements;

    root.querySelectorAll('*').forEach((element) => {
      elements.push(element);
      if (element.shadowRoot) collectElements(element.shadowRoot, elements);
    });

    return elements;
  };

  const scoreNativePanel = (element) => {
    if (!(element instanceof Element) || promo?.contains(element) || rewardDialog?.contains(element)) return -1;

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (
      rect.width < 280 ||
      rect.width > (desktop.matches ? Math.min(680, viewportWidth * .82) : viewportWidth + 2) ||
      rect.height < 180 ||
      rect.height > viewportHeight ||
      rect.top < -2 ||
      rect.right < viewportWidth - 120 ||
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      Number(style.opacity) === 0
    ) {
      return -1;
    }

    const text = getText(element);
    let score = Math.min(rect.width * rect.height / 1000, 220);
    const role = element.getAttribute('role');
    const part = element.getAttribute('part') || '';
    const name = `${element.tagName} ${element.className || ''} ${part}`.toLowerCase();

    if (element.tagName === 'DIALOG') score += 120;
    if (role === 'dialog') score += 100;
    if (element.hasAttribute('popover')) score += 70;
    if (/dialog|sheet|modal/.test(name)) score += 55;
    if (/sign in|create account/.test(text)) score += 160;
    if (text.includes('email')) score += 30;
    if (text.includes('orders') || text.includes('profile')) score += 20;
    score += Math.max(0, 70 - Math.abs(viewportWidth - rect.right));
    score += Math.max(0, 40 - rect.top);

    return score;
  };

  const pickBestPanel = (candidates) =>
    candidates.reduce(
      (best, element) => {
        const score = scoreNativePanel(element);
        return score > best.score ? { element, score } : best;
      },
      { element: null, score: -1 }
    ).element;

  const findNativePanel = () => {
    const accountCandidates = [];

    accounts.forEach((account) => {
      if (account.shadowRoot) collectElements(account.shadowRoot, accountCandidates);
    });

    const accountPanel = pickBestPanel(accountCandidates);
    if (accountPanel) return accountPanel;

    const documentCandidates = [];
    collectElements(document, documentCandidates);
    return pickBestPanel(documentCandidates);
  };

  const isPromoViewport = () => desktop.matches || mobile.matches;

  const syncGeometry = () => {
    if (!promo || !isPromoViewport() || !promo.matches(':popover-open')) return;

    if (scoreNativePanel(nativePanelCache) < 0) {
      nativePanelCache = findNativePanel();
    }

    if (!nativePanelCache) return;

    const rect = nativePanelCache.getBoundingClientRect();
    const viewportPadding = 12;

    if (desktop.matches) {
      const benefitsWidth = Math.max(260, Math.min(310, rect.left - viewportPadding));

      promo.style.setProperty('--quick-account-benefits-width', `${benefitsWidth}px`);
      promo.style.setProperty('--quick-account-native-width', `${rect.width}px`);
      promo.style.setProperty('--quick-account-native-height', `${rect.height}px`);
      promo.style.setProperty('--quick-account-native-top', `${Math.max(0, rect.top)}px`);

      const viewportRight = document.documentElement.clientWidth;
      const measuredInlineGap = Math.max(0, viewportRight - rect.right);
      const nativeOuterInset = 16;
      const nativeShellOffset = Math.max(0, measuredInlineGap - nativeOuterInset);

      promo.style.setProperty(
        '--quick-account-native-right',
        `${Math.max(0, window.innerWidth - rect.right - nativeShellOffset)}px`
      );
      return;
    }

    const viewportWidth = window.innerWidth;
    const mobileWidth = viewportWidth;
    const mobileLeft = 0;

    promo.style.setProperty('--quick-account-mobile-width', `${mobileWidth}px`);
    promo.style.setProperty('--quick-account-mobile-left', `${mobileLeft}px`);

    const reward = promo.querySelector('.quick-account-promo__reward');
    const rewardHeight = reward?.getBoundingClientRect().height || promo.getBoundingClientRect().height;
    const mobileTop = Math.max(viewportPadding, rect.top - rewardHeight);

    promo.style.setProperty('--quick-account-mobile-top', `${mobileTop}px`);
  };

  const startSync = () => {
    window.clearInterval(syncTimer);
    syncGeometry();
    syncTimer = window.setInterval(syncGeometry, 200);
  };

  const stopSync = () => {
    window.clearInterval(syncTimer);
    syncTimer = undefined;
    nativePanelCache = undefined;
  };

  const showPromo = () => {
    if (!promo || !isPromoViewport() || typeof promo.showPopover !== 'function') return;

    window.requestAnimationFrame(() => {
      if (!promo.matches(':popover-open')) promo.showPopover();
      syncGeometry();
      window.requestAnimationFrame(syncGeometry);
      startSync();
    });
  };

  function hidePromo() {
    stopSync();
    if (promo?.matches(':popover-open')) promo.hidePopover();
  }

  accounts.forEach((account) => {
    account.addEventListener('open', () => {
      if (isSignedOutAvatarVisible(account)) {
        window.sessionStorage.setItem(autoOpenKey, 'true');
        recordLoginIntent();
        showPromo();
      } else {
        hidePromo();
      }
    });
    account.addEventListener('close', hidePromo);
  });

  rewardTrigger?.addEventListener('click', openReward);
  copyCodeButton?.addEventListener('click', copyRewardCode);
  loginHintClose?.addEventListener('click', hideLoginHint);

  rewardDialog?.addEventListener('click', (event) => {
    if (event.target === rewardDialog) rewardDialog.close();
  });

  window.addEventListener('blur', () => {
    if (!signedIn && hasRecentLoginIntent()) leftDuringLogin = true;
  });

  window.addEventListener('focus', () => {
    window.setTimeout(() => {
      syncLoginState();
      if (leftDuringLogin && !signedIn) showLoginHint();
      leftDuringLogin = false;
    }, 500);
  });

  const handlePromoViewportChange = () => {
    if (!isPromoViewport()) {
      hidePromo();
      return;
    }

    nativePanelCache = undefined;
    syncGeometry();
  };

  desktop.addEventListener('change', handlePromoViewportChange);
  mobile.addEventListener('change', handlePromoViewportChange);

  window.addEventListener('resize', syncGeometry, { passive: true });

  customElements.whenDefined('shopify-account').then(() => {
    window.setTimeout(() => {
      accountReady = true;
      syncLoginState();
      window.setTimeout(maybeAutoOpenAccount, 900);
      window.clearInterval(loginStateTimer);
      loginStateTimer = window.setInterval(syncLoginState, 500);
    }, 250);
  });
});